module.exports = __webpack_public_path__ + "img/carrito.c10bf70b.svg";